<template>
    <div class="mt-8">
        <h3 class="text-xl font-bold text-gray-800 mb-4">Input Radio</h3>

        <div class="flex gap-4">
            <Radio id="red-pill" v-model:checked="pill" name="pill" label="Red Pill" value="red" />
            <Radio id="blue-pill" v-model:checked="pill" name="pill" label="Blue Pill" value="blue"/>
            <Radio id="disabled-pill" v-model:checked="pill" name="pill" label="Disabled Pill" disabled />
        </div>

        <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Input Checkbox</h3>

        <div class="flex gap-4">
            <Checkbox id="cb-red-pill" name="cb-red-pill" label="Red Pill" />
            <Checkbox id="cb-blue-pill" name="cb-blue-pill" label="Blue Pill" />
            <Checkbox id="cb-disabled-pill" name="cb-disabled-pill" label="Disabled Pill" disabled />
        </div>

        <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Select</h3>

        <div class="flex gap-4">
            <Select placeholder="Selecione" :options="selectOptions"/>
        </div>
        <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Entrada de Texto</h3>

        <label class="items-center mb-4 block">
            <span class="mb-1 mr-5 flex font-semibold">Label</span>
            <Input type="text" class="w-4/12" placeholder="Texto reservado"/>
            <span class="ml-8 w-30">Entrada de Texto - Padrão</span>
        </label>

        <label class="items-center mb-4 block">
            <span class="mb-1 mr-5 flex font-semibold">Label</span>
            <Input type="text" class="w-4/12" :state="'success'" placeholder="Texto reservado"/>
            <span class="ml-8 w-30">Entrada de Texto - Sucesso</span>
        </label>

        <label class="items-center mb-4 block">
            <span class="mb-1 mr-5 flex font-semibold">Label</span>
            <Input type="text" class="w-4/12" :state="'error'" placeholder="Texto reservado"/>
            <span class="ml-8 w-30">Entrada de Texto - Erro</span>
        </label>

        <label class="items-center mb-4 block">
            <span class="mb-1 mr-5 flex font-semibold">Label</span>
            <Input type="text" class="w-4/12" placeholder="Texto reservado" disabled/>
            <span class="ml-8">Entrada de Texto - Desabilitado</span>
        </label>

        <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Texto alternativo</h3>

        <label class="items-center mb-4 block">
            <span class="mb-1 mr-5 flex font-semibold">Texto Alternativo (Alt Text)</span>
            <textarea class="form-textarea w-3/12 border rounded resize-none" rows="3" placeholder="Descreva a mensagem..."></textarea>
        </label>

    </div>
</template>

<script>
import Radio from '@/Components/UI/Form/Radio.vue'
import Checkbox from '@/Components/UI/Form/Checkbox.vue'
import Select from '@/Components/UI/Form/Select.vue'
import Input from '@/Components/UI/Form/Input.vue'

export default {
    components: {
        Radio,
        Checkbox,
        Select,
        Input
    },
    data(){
        return {
            pill: 'null',
            selectOptions: {
                australia: 'Australia',
                brazil: 'Brazil',
                usa: 'United States',
            }
        }
    },
    methods: {
        alert(){
            alert(this.pill)
        }
    }
}
</script>
